import { AnyAction } from 'redux';
import { ThunkMiddleware } from 'redux-thunk';
import { browserHistory } from 'react-router';

import {
  getFromStorage,
  setInStorage,
  removeFromStorage,
} from 'ha/utils/storage';
import { GlobalState } from 'ha/types/store';
import { AppServices } from 'ha/services/getAppServices';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';

import showModal from '../actions/showModal';
import { Actions, Modals } from '../constants';

const isAcceptedAction = ({ type }: { type: string }) =>
  [Actions.INITIALIZE, Actions.SHOW_CONTACT_MODAL].find(
    actionName => actionName === type,
  );

export default (
  history: typeof browserHistory,
): ThunkMiddleware<GlobalState, AnyAction, AppServices> => ({
  dispatch,
  getState,
}) => next => action => {
  if (!isAcceptedAction(action)) {
    return next(action);
  }

  const isAuthenticated = getIsAuthenticated(getState());

  if (action.type === Actions.SHOW_CONTACT_MODAL) {
    if (isAuthenticated) {
      dispatch(showModal(Modals.CONTACT));
    } else {
      const location = history.getCurrentLocation();

      dispatch(
        NavBarActions.showModal(
          'register',
          `${location.pathname}${location.search}`,
        ),
      );
    }

    return next(action);
  }

  const roomId = action.payload.id;

  next(action);

  if (isAuthenticated) {
    return null;
  }
  const visitedRooms: string[] = getFromStorage('visitedRooms') || [];

  if (visitedRooms.includes(roomId)) {
    return null;
  }

  if (visitedRooms.length >= 1) {
    const location = history.getCurrentLocation();

    dispatch(
      NavBarActions.showModal(
        'register',
        `${location.pathname}${location.search}`,
      ),
    );

    return removeFromStorage('visitedRooms');
  }

  return setInStorage('visitedRooms', [...visitedRooms, roomId]);
};
